import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Outlet, Navigate } from "react-router-dom";
import { isVendorUser } from "./AuthState";
//import NavBar from "../components/NavBar";

function VendorRoutes() {
  const { userInformation } = useContext(UserContext);
  const isVendor = isVendorUser(userInformation);

  return isVendor ? (
    <>
      <Outlet />
    </>
  ) : (
    <Navigate to="/" />
  );
}

export default VendorRoutes;
